<template>
    <div class="col-md-6 drop-lg">

        <div v-if="canUpdatePaymentOptions">
            <div class="payment-group sau-bx-payment active d-flex-column h-100 justify-content-center pb-12 border-grey-400 hover:border-grey-400 cursor-default">
                <div>
                    <span class="mt-2"></span>
                    <img src="/img/bpay-landscape.gif" alt="BPay" class="mb-2">
                    <p class="mt-2"><a href="#" id="bpay-popover-main" class="sau-font sm">View BPAY Biller Code</a></p>
                    <b-popover target="bpay-popover-main" placement="top" triggers="hover focus">
                        <sau-utility-bpay></sau-utility-bpay>
                    </b-popover>
                </div>
            </div>
        </div>
        <div v-else @click.prevent="setPaymentMethod('bpay')">
            <div class="payment-group sau-select lg center payment d-flex-column h-100 justify-content-center pb-12 border-grey-400 hover:border-grey-400 cursor-default" :class="{ selected: this.paymentMethodSelected === 'bpay' }">
                <label for="bpay">
                    <input id="bpay" type="radio" name="payment-type" value="bpay" v-model="this.paymentMethodSelected">
                    <span class="mt-2"></span>
                    <img src="/img/bpay-landscape.gif" alt="BPay">
                    <a href="#" id="bpay-popover-main" class="sau-font sm">View BPAY Biller Code</a>

                    <b-popover target="bpay-popover-main" placement="top" triggers="hover focus">
                        <sau-utility-bpay></sau-utility-bpay>
                    </b-popover>
                </label>
            </div>
        </div>

    </div>
</template>

<script>

    import { mapGetters } from 'vuex';

    export default {
        computed: {
            ...mapGetters(['canUpdatePaymentOptions']),
        }
    }

</script>
